<button
  matRipple
  (click)="copyLink()"
  class="button"
  [disabled]="!link"
  [title]="'copy_link.copy_selectedMediaItem_hover' | translate"
  [class.success]="buttonText === 'copy_link.copy_success'"
>
  {{ buttonText | translate }}
</button>
